import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';
import Swal from 'sweetalert2';
import PDCEdit from './PumpDC/Edit';
import MDCEdit from './ManufacturingDC/Edit';

function DcEdit() {
  const navigate = useNavigate();
  const { pointindex, id } = useParams();
  const [deliverychallantype, setdeliverychallantype] = useState();
  const [deliverychallancategory, setdeliverychallancategory] = useState();
  const [enquiryData, setenquiryData] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}deliveryChallan/findById/${id}`, {
          headers: authHeader(),
        });
        console.log(' id api', response.data);
        setenquiryData(response.data);
        setdeliverychallantype(response.data.deliverychallantype);
        setdeliverychallancategory(response.data.deliverychallancategory);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);
  console.log('aa ', enquiryData);

  const renderPageDisplay = () => {
    if (deliverychallantype === 'Pump Spare' && deliverychallancategory === 'Domestic') {
      return <PDCEdit enquiryData={enquiryData} />;
    } else if (deliverychallantype === 'Manufacturing' && deliverychallancategory === 'Domestic') {
      return <MDCEdit enquiryData={enquiryData} />;
    }
    return null; // Default case
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(`${BASE_URL}deliveryChallan/delete/${id}`, {
          headers: authHeader(),
        });
        if (response.data.length === 0) {
          Swal.fire('Warning', 'PO is present in another module. Delete operation has been cancelled.', 'warning');
        } else {
          navigate(`/dcindex/${pointindex}`);
          Swal.fire('Deleted!', 'Deleted successfully.', 'success');
        }
      } catch (error) {
        Swal.fire('Error', error.response?.data || 'An error occurred', 'error');
      }
    }
  };

  return (
      <Card className="card">
        <Card.Header className="card-header">
          <h6>UPDATE DELIVERY CHALLAN</h6>
          <div className="view-buttons">
            {/* Uncomment buttons if needed */}
            {/* <Link to={`/dctosalesconvert/${id}`}>
              <button className="button-70">Convert To Sales</button>
            </Link> */}
            {/* <button className="button-70" onClick={() => handleDelete(id)}>DELETE</button> */}
            {/* <Link to={`/dcEdit/${id}/${pointindex}`}>
              <button className="button-70">EDIT</button>
            </Link> */}
            <Link to={`/dcindex/${pointindex}`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select Product Type:</Form.Label>
                <Form.Select
                  disabled
                  value={deliverychallantype}
                  onChange={(e) => setdeliverychallantype(e.target.value)}
                >
                  <option value="">--Please choose an option--</option>
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select Product Category:</Form.Label>
                <Form.Select
                  disabled
                  value={deliverychallancategory}
                  onChange={(e) => setdeliverychallancategory(e.target.value)}
                >
                  <option value="">--Please choose an option--</option>
                  <option value="Domestic">Domestic</option>
                </Form.Select>
              </Form.Group>
            </Col>
            {renderPageDisplay()}
          </Row>
        </Card.Body>
      </Card>
  );
}

export default DcEdit;
